export default "__VITE_ASSET__C2VX5TeU__"